import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import RegisterForm from './components/RegisterForm';
import LoginForm from './components/LoginForm';
import CreateHistoryForm from './components/CreateHistoryForm';
import CreateEventForm from './components/CreateEventForm';
import HistoryList from './components/HistoryList';
import Home from './components/Home';
import RegistrationSuccess from './components/RegistrationSuccess';
import EditHistoryForm from './components/EditHistoryForm';
import EditEventForm from './components/EditEventForm';
import Footer from './components/Footer';
import Terms from './components/Terms';
import Study from './components/Study';
import { useState, useEffect } from 'react';
import { getCurrentUser, logoutUser } from './services/authService';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchUser = async () => {
      try {
        const data = await getCurrentUser();
        setUser(data);
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const handleLogout = async () => {
    await logoutUser();

    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    setUser(null);
  };

  if (isLoading) {
    return <div className="bg-gray-200 h-screen flex justify-center items-center">Loading...</div>;
  }

  return (
    <div className="bg-gray-200 min-h-screen flex flex-col">
      <BrowserRouter>
        <nav className="p-4 bg-white shadow-md px-8">
          <Link to="/" className="mr-10 border-2 border-gray-200 rounded-full px-2 py-1 hover:bg-gray-100">
            Home
          </Link>
          {user ? 
            <>
            <Link to="/historyList" className="mr-4 border-2 border-gray-200 rounded-full px-2 py-1 hover:bg-gray-100">
              History list
            </Link>
            <Link to="/createHistory" className="mr-20 border-2 border-gray-200 rounded-full px-2 py-1 hover:bg-gray-100">
              Create History
            </Link>
            <span className="mr-8">Logged in as { user.email }</span>
            <button onClick={handleLogout} className="rounded-full bg-red-500 px-2 py-[2px] text-white hover:bg-red-700">Logout</button>
            </>
            :
            <Link to="/login" className="border-2 border-gray-200 rounded-full px-2 py-1 hover:bg-gray-100">
              Sign in
            </Link>
          }
        </nav>
        <Routes>
          <Route path="/" element={<Home user={user} />} />
          <Route 
            path="/login" 
            element={
              <ProtectedRoute user={user} onlyUnauth={true}>
                <LoginForm onLoginSuccess={fetchUser} />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/register" 
            element={
              <ProtectedRoute user={user} onlyUnauth={true}>
                <RegisterForm onLoginSuccess={fetchUser}/>
              </ProtectedRoute>
            }
          />
          <Route 
            path="/createHistory"
            element={
              <ProtectedRoute user={user}>
                <CreateHistoryForm />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/historyList" 
            element={
              <ProtectedRoute user={user}>
                <HistoryList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/registration-success"
            element={
              <ProtectedRoute user={user} onlyUnauth={true}>
                <RegistrationSuccess />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/createEvent/:historyId"
            element={
              <ProtectedRoute user={user}>
                <CreateEventForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/editHistory/:historyId"
            element={
              <ProtectedRoute user={user}>
                <EditHistoryForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/editEvent/:eventId"
            element={
              <ProtectedRoute user={user}>
                <EditEventForm />
              </ProtectedRoute>
            }
          />
          <Route path="/terms" element={<Terms />} />
          <Route 
            path="/study/:historyId"
            element={
              <ProtectedRoute user={user}>
                <Study user={user} />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
